export default __webpack_public_path__ + "static/media/skills-gameLoopPF.3c61e37b.png";